import moment from 'moment';

const MINUS_MONTHS = 24;

const getMonthsOptions = () => {
	const options = [];
	for (let i = 0; i < MINUS_MONTHS; i++) {
		const m = moment().subtract(i, 'months');
		options.push({
			label: m.format('MMMM YYYY'),
			value: m.format('YYYY/MM'),
		});
	}
	return options;
};

export const MONTHS_OPTIONS = getMonthsOptions();

export const VIEW_TYPE_ENUM = {
	DAILY: 'daily',
	MONTHLY: 'monthly',
};

export const VIEW_TYPE_OPTIONS = [
	{ label: 'Daily', value: VIEW_TYPE_ENUM.DAILY },
	{ label: 'Monthly', value: VIEW_TYPE_ENUM.MONTHLY },
];
